export enum PricingEntityTypes {
  AllProducts,
  Brands,
  Categories,
  Collections,
  Products,
  Competitors,
  NoCompetitionProducts,
}
